import { Helmet } from "react-helmet-async";
import { useNavigate, useSearchParams } from "react-router-dom";
import {
  Stack,
  Container,
  Typography,
  Grid,
  Button
} from "@mui/material";
import Iconify from "../components/iconify";
import EditDivisions from "../components/divisions/EditDivisions";

export default function DivisionsSettingsPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const tenantId = searchParams.get("tenantId");

  const handleBackToDivisions = () => {
    const base = '/dashboard/divisions';
    if (tenantId && tenantId.trim() !== '') {
      navigate(`${base}?tenantId=${tenantId}`);
    } else {
      navigate(base);
    }
  };

  return (
    <>
      <Helmet>
        <title> Divisions Settings </title>
      </Helmet>

      <Container>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          mb={0}
        >
          <Typography variant="h4" gutterBottom>
            Divisions Settings
          </Typography>
          <Button
            variant="outlined"
            color="primary"
            startIcon={<Iconify icon="eva:arrow-back-fill" />}
            onClick={handleBackToDivisions}
            sx={{
              borderColor: 'primary.main',
              color: 'primary.main',
              '&:hover': {
                backgroundColor: 'primary.50',
                borderColor: 'primary.main',
              }
            }}
          >
            Back To Divisions
          </Button>
        </Stack>
        <Grid container>
          <Grid item xs={6}>
            <EditDivisions />
          </Grid>
        </Grid>
      </Container>
    </>
  );
}
